import type { AssetLibraryModalContentProps } from '@/components/AssetModalContent/type';

/** 完整资产库可浏览 IP；专用图片 picker 必须提供 IP 媒体适配视图，避免破坏媒体回调。 */
export function canShowMyIpAssetCategory({
  enableIpCategory, browseIpCategory, ipCategoryContent, pickerSource, allowedMaterialTypes,
  onAssetItemClick, onAssetBatchConfirm, onAssetBatchItemClick,
}: AssetLibraryModalContentProps): boolean {
  if (enableIpCategory === true && browseIpCategory) return true;
  if (pickerSource || allowedMaterialTypes) {
    return enableIpCategory === true && ipCategoryContent != null && pickerSource === 'subjectLibrary'
      && allowedMaterialTypes?.length === 1 && allowedMaterialTypes[0] === 'image';
  }
  return enableIpCategory ?? (!onAssetItemClick && !onAssetBatchConfirm && !onAssetBatchItemClick);
}
